<div id="dynamicForm-form-div" class="phoneDiv">
  <span class="symbolIcon" style="font-size: 1.3rem">+</span>
  <mat-form-field id="inputCOMP-form" [formGroup]="group" class="custom-form-field phoneCodeDiv">
    <mat-label>{{ countryCodeJson.displayName }}</mat-label>
    <input
      matInput
      [formControlName]="countryCodeJson.name"
      [name]="countryCodeJson.name"
      [type]="countryCodeJson.inputType"
      title="Country Code"
      autocomplete="off"
      [required]="field?.isRequired"
    />
    @for (validation of countryCodeJson.validations; track validation) {
      <ng-container id="inputCOMP-form-ng-container" ngProjectAs="mat-error">
        @if (group.get(countryCodeJson.name).hasError(validation.name)) {
          <mat-error id="inputCOMP-form-error{{ countryCodeJson.name }}">{{ validation.message }}</mat-error>
        }
      </ng-container>
    }
  </mat-form-field>
  <span class="symbolIcon" style="font-size: 2rem">-</span>
  <mat-form-field id="inputCOMP-form" [formGroup]="group" class="custom-form-field phoneNumDiv">
    <mat-label>{{ field.displayName }}</mat-label>
    <input
      matInput
      [formControlName]="field.name"
      [name]="field.name"
      [type]="field.inputType"
      title="Mobile(without country code and area code)"
      autocomplete="off"
      [required]="field?.isRequired"
    />
    @for (validation of field.validations; track validation) {
      <ng-container id="inputCOMP-form-ng-container" ngProjectAs="mat-error">
        @if (group.get(field.name).hasError(validation.name)) {
          <mat-error id="inputCOMP-form-error{{ field.name }}"> {{ validation.message }}</mat-error>
        }
      </ng-container>
    }
  </mat-form-field>
</div>
